<template>
    <div class="email-listing-loader">
        <div v-if="displayHeaderLoader" class="email-listing-loader__header">
            <CompassSkeleton
                v-if="displayResultsLoader"
                class="email-listing-loader__results"
                size="large"
            />
            <CompassSkeleton
                v-if="displaySearchLoader"
                class="email-listing-loader__search"
                size="large"
            />
            <CompassSkeleton
                v-if="displayRefreshLoader"
                class="email-listing-loader__refresh"
                size="large"
            />
        </div>
        <div v-for="(_, index) in 10" :key="index" class="email-listing-loader__body">
            <CompassSkeleton size="large" />
        </div>
    </div>
</template>
<script>
export default {
    props: {
        displayHeaderLoader: {
            type: Boolean,
            default: true,
        },
        displayResultsLoader: {
            type: Boolean,
            default: true,
        },
        displaySearchLoader: {
            type: Boolean,
            default: false,
        },
        displayRefreshLoader: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
<style lang="scss" scoped>
.email-listing-loader {
    background-color: var(--colors-common-background-default);
    border: 1px solid var(--colors-common-border-default);
    border-radius: var(--spacing-0);

    &__header {
        align-items: center; // to be removed when filters are added to the header
        border-bottom: 1px solid var(--colors-common-border-default);
        display: flex;
        justify-content: flex-end;
        gap: var(--spacing-3);
        min-height: 64px;
        padding: var(--spacing-3);
    }

    &__results {
        width: 70px;
    }

    &__search {
        width: 240px;
    }

    &__refresh {
        width: 32px;
    }

    &__body {
        align-items: center;
        display: flex;
        min-height: 56px;
        padding: var(--spacing-2) var(--spacing-3);

        &:not(:last-child) {
            border-bottom: 1px solid var(--colors-common-border-default);
        }

        &::v-deep {
            .compass-skeleton {
                width: 100%;
            }
        }
    }
}
</style>
